
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2ZkUh", function(module, exports) {

var $gFF2G = parcelRequire("gFF2G");


var $ccWUN = parcelRequire("ccWUN");

/**
 * @generated SignedSource<<14bbd4e27dbcb4fef87c6ee9d75ba788>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d13c51a200f0d73e$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ArchivedPageBannerV2_content",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "operation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            },
            {
                "concreteType": "ArchivedContentMetadata",
                "kind": "LinkedField",
                "name": "archivedContentMetadata",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "archiveNote"
                    }
                ]
            },
            {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "lastUpdated",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "by",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v0 /*: any*/ ,
                                        "type": "KnownUser"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v0 /*: any*/ ,
                                        "type": "UnknownUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$d13c51a200f0d73e$var$node.hash = "5d436ce04af0e59d7af1d44cc8ac90df";
var $d13c51a200f0d73e$export$2e2bcd8739ae039 = $d13c51a200f0d73e$var$node;


/**
 * @generated SignedSource<<a8648b81a2eeb68331b747b6ba0ee314>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $accc41d680de2a43$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ArchivedPageBannerV2Status_content",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$accc41d680de2a43$var$node.hash = "796cb3cff58c88eeb0ad9572d8c6b4df";
var $accc41d680de2a43$export$2e2bcd8739ae039 = $accc41d680de2a43$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $gXfti = parcelRequire("gXfti");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $kpLJY = parcelRequire("kpLJY");


var $jmjWc = parcelRequire("jmjWc");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $12UWa = parcelRequire("12UWa");


var $aqBZ0 = parcelRequire("aqBZ0");

const $cd458192e783a00b$export$b80499539853a49c = (0, $accc41d680de2a43$export$2e2bcd8739ae039);
const $cd458192e783a00b$export$a64b58b185dd8958 = (0, $d13c51a200f0d73e$export$2e2bcd8739ae039);

const $cd458192e783a00b$var$LazyUnarchivePagesLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4vFoR",
    name: "LazyUnarchivePagesLoader",
    loader: async ()=>(await (parcelRequire("eQJAE"))).UnarchivePagesLoader
});

const $cd458192e783a00b$var$LazyArchivedPageBannerContent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fisHC",
    name: "LazyArchivedPageBannerContent",
    loader: async ()=>(await (parcelRequire("hPs8p"))).ArchivedPageBannerContent
});
const $cd458192e783a00b$var$hasFragmentSpread = (fragmentRef)=>Boolean(fragmentRef?.[' $fragmentSpreads']);
const $cd458192e783a00b$var$hasDirectField = (fragmentRef, fieldName)=>Boolean(fragmentRef && typeof fragmentRef === 'object' && Object.prototype.hasOwnProperty.call(fragmentRef, fieldName));
const $cd458192e783a00b$var$isMatchingContentId = (value, contentId)=>// oxlint-disable-next-line prefer-template
    value === contentId || value === 'Content:' + contentId;
const $cd458192e783a00b$var$ArchivedPageBannerWithMetadata = ({ contentId: contentId, marginStyle: marginStyle = 'bottom', contentStatus: contentStatus, statusContentId: statusContentId, statusError: statusError, statusRefetch: statusRefetch, onPageRestore: onPageRestore, noteDataContent: noteDataContent, noteDataError: noteDataError })=>{
    const isContentArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
    // Note that when the user changes to a different page/content item, this component remains
    // mounted and will fetch the data for the new page, but the old status data can still be
    // available while the new data is being fetched. So the new data isn't really ready until
    // we see that the data has the correct contentId in it.
    const isStatusDataAvailable = contentStatus && $cd458192e783a00b$var$isMatchingContentId(statusContentId, contentId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // We need to keep the success atrributes object reference constant, as creating and assigning a
    // whole new object on every render pass will cause ExperienceSuccess's useEffect() to think
    // something has changed and it will fire the "success" event again. But if we keep the same
    // object across renders and just set the "archivedPageBannerShown" value, then ExperienceSuccess
    // sees no change there and will only fire again if something else has changed.
    const successAttributes = (0, $cozmU.useMemo)(()=>({
            archivedPageBannerShown: false
        }), []);
    const getUnarchiveDialogOpener = (0, $cozmU.useCallback)((dialogs)=>()=>{
            (0, $12UWa.fireUIClickEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                actionSubject: 'restoreButton',
                actionSubjectId: contentId,
                source: (0, $aqBZ0.ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE)
            });
            experienceTracker.start({
                name: (0, $irVI7.RESTORE_PAGES_EXPERIENCE)
            });
            dialogs.showModal($cd458192e783a00b$var$LazyUnarchivePagesLoader, {
                contentId: contentId,
                onPageRestore: onPageRestore || statusRefetch,
                source: (0, $aqBZ0.ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE)
            });
        }, [
        contentId,
        createAnalyticsEvent,
        experienceTracker,
        onPageRestore,
        statusRefetch
    ]);
    const fireLearnMoreEvent = (0, $cozmU.useCallback)(()=>(0, $12UWa.fireUIClickEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            actionSubject: 'link',
            actionSubjectId: 'restoreLearnMore',
            source: (0, $aqBZ0.ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE)
        }), [
        createAnalyticsEvent
    ]);
    const userCanRestorePage = (0, $kpLJY.canRestoreContent)([
        ...noteDataContent?.operations || []
    ]);
    const archiveNote = noteDataContent?.archivedContentMetadata?.archiveNote || '';
    // accountId does not exist on Anonymous user type, so we need to use bracket notation to get the property or undefined
    const archiverAccountId = noteDataContent?.history?.lastUpdated?.by?.['accountId'];
    // Similar to the status data, if the user changes to a different page/content item, this
    // component will remain mounted and will fetch the data for the new page, but the old "noteData"
    // is still available while the new data is being fetched. So the new data isn't really ready
    // until we see that the data has the correct contentId in it.
    const isNoteDataAvailable = noteDataContent && $cd458192e783a00b$var$isMatchingContentId(noteDataContent?.id, contentId);
    // Only update the value; creating and assigning a whole new object will cause ExperienceSuccess's
    // useEffect() to think something has changed and it will fire the "success" event again.
    successAttributes.archivedPageBannerShown = isContentArchived;
    const isBannerRendered = isStatusDataAvailable && isContentArchived && !!noteDataContent;
    (0, $cozmU.useEffect)(()=>{
        if (isBannerRendered) (0, $gXfti.addUFOCustomData)({
            archivedPageBannerRendered: true
        });
    }, [
        isBannerRendered
    ]);
    const error = statusError || noteDataError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.ARCHIVED_PAGE_BANNER_EXPERIENCE),
        error: error
    })), isStatusDataAvailable && (!isContentArchived || !!isNoteDataAvailable) && // Note that using a "key" prop with the "contentId" here will make React create a new
    // ExperienceSuccess instance, which is useful because we can remain mounted when the user
    // changes to a different content item
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.ARCHIVED_PAGE_BANNER_EXPERIENCE),
        key: contentId,
        attributes: successAttributes
    }), isStatusDataAvailable && isContentArchived && noteDataContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$LazyArchivedPageBannerContent, {
        contentId: contentId,
        marginStyle: marginStyle,
        userCanRestorePage: userCanRestorePage,
        archiveNote: archiveNote,
        archiverAccountId: archiverAccountId,
        getUnarchiveDialogOpener: getUnarchiveDialogOpener,
        fireLearnMoreEvent: fireLearnMoreEvent
    }) : null);
};
const $cd458192e783a00b$var$ArchivedPageBannerRelayMetadataFragmentReader = ({ contentFragmentRef: contentFragmentRef, ...bannerProps })=>{
    const archivedContent = (0, $6SsN4.useFragment)($cd458192e783a00b$export$a64b58b185dd8958, contentFragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerWithMetadata, {
        ...bannerProps,
        noteDataContent: archivedContent ?? contentFragmentRef
    });
};
const $cd458192e783a00b$var$ArchivedPageBannerLegacyMetadataReader = ({ contentFragmentRef: contentFragmentRef, ...bannerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerWithMetadata, {
        ...bannerProps,
        noteDataContent: contentFragmentRef
    });
const $cd458192e783a00b$var$ArchivedPageBannerMetadataFragmentReader = (props)=>$cd458192e783a00b$var$hasFragmentSpread(props.contentFragmentRef) || !$cd458192e783a00b$var$hasDirectField(props.contentFragmentRef, 'archivedContentMetadata') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerRelayMetadataFragmentReader, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerLegacyMetadataReader, props);
const $cd458192e783a00b$var$ArchivedPageBannerWithStatus = ({ contentId: contentId, marginStyle: marginStyle = 'bottom', contentStatus: contentStatus, statusContentId: statusContentId, statusError: statusError, statusRefetch: statusRefetch, useMetadataFragmentReader: useMetadataFragmentReader, onPageRestore: onPageRestore })=>{
    const isContentArchived = $cd458192e783a00b$var$isMatchingContentId(statusContentId, contentId) && contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
    // If the content is not archived, then we MUST NOT do the second query for the archive note
    // info because that query will fail!
    const { error: noteDataError, data: noteData } = (0, $jMyy4.useQueryInterop)((0, $ccWUN.default), {
        variables: {
            contentId: contentId
        },
        skip: !isContentArchived,
        fetchPolicy: 'cache-and-network',
        __callerPackage__: "archive-pages"
    });
    const noteDataContent = noteData?.content?.nodes?.[0];
    if (noteDataContent && useMetadataFragmentReader) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerMetadataFragmentReader, {
        contentId: contentId,
        marginStyle: marginStyle,
        contentStatus: contentStatus,
        statusContentId: statusContentId,
        statusError: statusError,
        statusRefetch: statusRefetch,
        onPageRestore: onPageRestore,
        noteDataError: noteDataError,
        contentFragmentRef: noteDataContent
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerWithMetadata, {
        contentId: contentId,
        marginStyle: marginStyle,
        contentStatus: contentStatus,
        statusContentId: statusContentId,
        statusError: statusError,
        statusRefetch: statusRefetch,
        onPageRestore: onPageRestore,
        noteDataError: noteDataError,
        noteDataContent: noteDataContent
    });
};
const $cd458192e783a00b$var$ArchivedPageBannerQuery = ({ contentId: contentId, marginStyle: marginStyle = 'bottom', onPageRestore: onPageRestore })=>{
    const { error: statusError, data: statusData, refetch: statusRefetch } = (0, $jMyy4.useQueryInterop)((0, $gFF2G.default), {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'cache-and-network',
        __callerPackage__: "archive-pages"
    });
    const contentStatus = statusData?.content?.nodes?.[0]?.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerWithStatus, {
        contentId: contentId,
        marginStyle: marginStyle,
        contentStatus: contentStatus,
        statusContentId: statusData?.content?.nodes?.[0]?.id,
        statusError: statusError,
        statusRefetch: statusRefetch,
        onPageRestore: onPageRestore
    });
};
const $cd458192e783a00b$var$ArchivedPageBannerRelayStatusFragmentReader = ({ contentId: contentId, marginStyle: marginStyle = 'bottom', contentFragmentRef: contentFragmentRef, onPageRestore: onPageRestore })=>{
    const content = (0, $6SsN4.useFragment)($cd458192e783a00b$export$b80499539853a49c, contentFragmentRef);
    const directContent = contentFragmentRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerWithStatus, {
        contentId: contentId,
        marginStyle: marginStyle,
        contentStatus: content?.status ?? directContent?.status,
        statusContentId: content?.id ?? directContent?.id,
        useMetadataFragmentReader: true,
        onPageRestore: onPageRestore
    });
};
const $cd458192e783a00b$var$ArchivedPageBannerLegacyStatusReader = ({ contentId: contentId, marginStyle: marginStyle = 'bottom', contentFragmentRef: contentFragmentRef, onPageRestore: onPageRestore })=>{
    const content = contentFragmentRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerWithStatus, {
        contentId: contentId,
        marginStyle: marginStyle,
        contentStatus: content?.status,
        statusContentId: content?.id,
        useMetadataFragmentReader: true,
        onPageRestore: onPageRestore
    });
};
const $cd458192e783a00b$var$ArchivedPageBannerStatusFragmentReader = (props)=>$cd458192e783a00b$var$hasFragmentSpread(props.contentFragmentRef) || !$cd458192e783a00b$var$hasDirectField(props.contentFragmentRef, 'status') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerRelayStatusFragmentReader, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerLegacyStatusReader, props);
const $cd458192e783a00b$var$ArchivedPageBannerComponent = (props)=>{
    const { contentFragmentRef: contentFragmentRef } = props;
    if (contentFragmentRef && (0, $9wGTI.fg)('confluence_vp_meta_frag_reader')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerStatusFragmentReader, {
        ...props,
        contentFragmentRef: contentFragmentRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerQuery, props);
};
const $cd458192e783a00b$export$a32ab742d345a2c9 = ({ contentId: contentId, marginStyle: marginStyle, contentFragmentRef: contentFragmentRef, onPageRestore: onPageRestore })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.ARCHIVED_PAGE_BANNER_EXPERIENCE),
        key: contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd458192e783a00b$var$ArchivedPageBannerComponent, {
        contentId: contentId,
        marginStyle: marginStyle,
        contentFragmentRef: contentFragmentRef,
        onPageRestore: onPageRestore
    }));
module.exports["ArchivedPageBannerV2Status_content"] = $cd458192e783a00b$export$b80499539853a49c;
module.exports["ArchivedPageBannerV2_content"] = $cd458192e783a00b$export$a64b58b185dd8958;
module.exports["ArchivedPageBanner"] = $cd458192e783a00b$export$a32ab742d345a2c9;

});

parcelRegister("gFF2G", function(module, exports) {
/**
 * @generated SignedSource<<b09412736b8beecddca9546c0e2759d4>>
 * @relayHash 30a7ec0bd1bc84739eda7e4fe244b93f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d
const $385b63e5393fb4b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "30a7ec0bd1bc84739eda7e4fe244b93f",
            "id": "0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerContainerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,status}}}"
        }
    };
}();
$385b63e5393fb4b0$var$node.hash = "c639141edd782146ad296893dc79f146";
var $385b63e5393fb4b0$export$2e2bcd8739ae039 = $385b63e5393fb4b0$var$node;
module.exports["default"] = $385b63e5393fb4b0$export$2e2bcd8739ae039;

});

parcelRegister("ccWUN", function(module, exports) {
/**
 * @generated SignedSource<<655e5b5d54928e9a3dbeab0fae4a36b9>>
 * @relayHash b9d1efe6b1cd056569e39345117f0c88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81989b0b417d33031602bc94683f12b047f59581ccbc8926b307e0c037ab314c
const $462dea7d21a073f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v5 = {
        "concreteType": "ArchivedContentMetadata",
        "kind": "LinkedField",
        "name": "archivedContentMetadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "archiveNote"
            }
        ]
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "KnownUser"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "UnknownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "lastUpdated",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ArchivedPageBannerV2_content"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "lastUpdated",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b9d1efe6b1cd056569e39345117f0c88",
            "id": "81989b0b417d33031602bc94683f12b047f59581ccbc8926b307e0c037ab314c",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,type,operations{operation,targetType},archivedContentMetadata{archiveNote},history{lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}},...ArchivedPageBannerV2_content}}}fragment ArchivedPageBannerV2_content on Content{id,type,operations{operation,targetType},archivedContentMetadata{archiveNote},history{lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}"
        }
    };
}();
$462dea7d21a073f6$var$node.hash = "f6e1082054df2975d0307494e9090b59";
var $462dea7d21a073f6$export$2e2bcd8739ae039 = $462dea7d21a073f6$var$node;
module.exports["default"] = $462dea7d21a073f6$export$2e2bcd8739ae039;

});

parcelRegister("gfIPU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("kpLJY", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $0a26534720307814$var$isValidContentType = (contentType)=>{
    if (!contentType) return false;
    return (0, $1ggpj.VALID_OPERATION_TARGETS).includes(contentType);
};
const $0a26534720307814$export$482055539d5cd058 = (operations)=>{
    if (operations) return operations.some((singleOperation)=>{
        return $0a26534720307814$var$isValidContentType(singleOperation?.targetType) && singleOperation?.operation === 'archive';
    });
    return false;
};
const $0a26534720307814$export$c1a3ac49d9650e25 = (operations)=>{
    if (operations) return operations.some((singleOperation)=>{
        return $0a26534720307814$var$isValidContentType(singleOperation?.targetType) && singleOperation?.operation === 'delete';
    });
    return false;
};
const $0a26534720307814$export$b70e008aef4dbd20 = (operations)=>$0a26534720307814$export$482055539d5cd058(operations);
const $0a26534720307814$export$45c8d206d1e3c1a5 = (operations)=>$0a26534720307814$export$482055539d5cd058(operations);
module.exports["canArchiveContent"] = $0a26534720307814$export$482055539d5cd058;
module.exports["canDeleteContent"] = $0a26534720307814$export$c1a3ac49d9650e25;
module.exports["canRestoreContent"] = $0a26534720307814$export$b70e008aef4dbd20;
module.exports["canEditContentArchiveNote"] = $0a26534720307814$export$45c8d206d1e3c1a5;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    FeedbackSource["TABS"] = "Tabs";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("12UWa", function(module, exports) {
const $d42c1236b5cc8ac8$export$d569af9d235186c9 = (isArchive, isBulk = false)=>isArchive ? isBulk ? 'bulkArchive' : 'archive' : isBulk ? 'bulkRestore' : 'restore';
const $d42c1236b5cc8ac8$export$a1562d08625f5d7e = 'sendUIEvent';
const $d42c1236b5cc8ac8$export$947dac6c72b26f81 = 'sendTrackEvent';
const $d42c1236b5cc8ac8$export$c2f50b86729b5b74 = 'selectDropdown';
const $d42c1236b5cc8ac8$export$fedfc172a3b39723 = 'spaceSelect';
const $d42c1236b5cc8ac8$export$79fc012ce0853550 = 'button';
const $d42c1236b5cc8ac8$export$7eca133280843f9e = (eventProps)=>$d42c1236b5cc8ac8$export$3e13615bb023ad8f({
        ...eventProps,
        type: $d42c1236b5cc8ac8$export$a1562d08625f5d7e
    });
const $d42c1236b5cc8ac8$export$5edee710fd3e881c = (eventProps)=>$d42c1236b5cc8ac8$export$7eca133280843f9e({
        ...eventProps,
        action: 'clicked'
    });
const $d42c1236b5cc8ac8$export$574d2f19a52d67ca = (eventProps)=>$d42c1236b5cc8ac8$export$3e13615bb023ad8f({
        ...eventProps,
        type: $d42c1236b5cc8ac8$export$947dac6c72b26f81
    });
const $d42c1236b5cc8ac8$export$59608e0169622110 = (eventProps)=>$d42c1236b5cc8ac8$export$3e13615bb023ad8f({
        ...eventProps,
        type: 'sendScreenEvent'
    });
const $d42c1236b5cc8ac8$export$3e13615bb023ad8f = (params)=>{
    const { createAnalyticsEvent: createAnalyticsEvent, type: type, ...data } = params;
    createAnalyticsEvent({
        type: type,
        data: data
    }).fire();
};
module.exports["getActionName"] = $d42c1236b5cc8ac8$export$d569af9d235186c9;
module.exports["fireUIClickEvent"] = $d42c1236b5cc8ac8$export$5edee710fd3e881c;
module.exports["fireTrackEvent"] = $d42c1236b5cc8ac8$export$574d2f19a52d67ca;
module.exports["fireScreenEvent"] = $d42c1236b5cc8ac8$export$59608e0169622110;

});

parcelRegister("aqBZ0", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("eQJAE", function(module, exports) {

let $acf9494a24d54a6e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $acf9494a24d54a6e$var$load("iWnyc"),
    $acf9494a24d54a6e$var$load("gaT5l"),
    $acf9494a24d54a6e$var$load("2Vm3g"),
    $acf9494a24d54a6e$var$load("dFbDj"),
    $acf9494a24d54a6e$var$load("6wr18"),
    $acf9494a24d54a6e$var$load("dRQ13"),
    $acf9494a24d54a6e$var$load("4QN8n"),
    $acf9494a24d54a6e$var$load("9pso5"),
    $acf9494a24d54a6e$var$load("LWh5V"),
    $acf9494a24d54a6e$var$load("251nM"),
    $acf9494a24d54a6e$var$load("kHXvF"),
    $acf9494a24d54a6e$var$load("excC5"),
    $acf9494a24d54a6e$var$load("ffEVr"),
    $acf9494a24d54a6e$var$load("7EorR"),
    $acf9494a24d54a6e$var$load("Wowvf"),
    $acf9494a24d54a6e$var$load("lkxmG"),
    $acf9494a24d54a6e$var$load("hhss7"),
    $acf9494a24d54a6e$var$load("dxDVc")
]).then(()=>parcelRequire('ew61I'));

});

parcelRegister("hPs8p", function(module, exports) {

let $cfad060bb5bd3614$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cfad060bb5bd3614$var$load("bWpNZ"),
    $cfad060bb5bd3614$var$load("kHXvF"),
    $cfad060bb5bd3614$var$load("iWnyc"),
    $cfad060bb5bd3614$var$load("hhss7"),
    $cfad060bb5bd3614$var$load("1lfwL")
]).then(()=>parcelRequire('932pg'));

});


//# sourceMappingURL=ArchivedPageBannerV2.ee645df5.js.map
